import { render, staticRenderFns } from "./PricingChart.vue?vue&type=template&id=230062c4&"
import script from "./PricingChart.vue?vue&type=script&lang=js&"
export * from "./PricingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports